<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md10, lg9)
          v-card(flat, text-xs-center)
            breadcrumb(back='page1-6')
              | Estás en: Elige tu Crédito Hipotecario / ¿Estoy listo para cursar esta lección?
            v-layout.px-4(row, justify-start)
              v-flex(xs6)
                v-card(flat)
                  v-card-media(height='576px', src='assets/TCH-L2.1-subportada.jpg')
              v-flex(xs6)
                v-card.ml-0.pl-0(flat, text-xs-start)
                  v-card-text.label16tt.withDividerLeft.ml-0.pl-0(style='color:#F7893B')
                    | RESULTADO FINAL
                  v-card-text.titulo60Book.ml-0.pl-0
                    | {{evaluation()}}/100
                  v-btn.btn.ml-0.pl-0(type='button', color='secondary', @click.prevent="nextPage('page1-2')")
                    | Revisar
                  div(v-if='60<=evaluation()')
                    v-card-text.titulo36Book.pt-5.ml-0.pl-0
                      b ¡Excelente!
                    v-card-text.parrafoDestacado18.ml-0.pl-0
                      | Te felicitamos pues todo indica que tienes los conocimientos necesarios para aprovechar al máximo la presente lección.
                  div(v-if='60>evaluation()')
                    v-card-text.parrafoDestacado18.ml-0.pl-0
                      | Para que tengas una mejor experiencia de aprendizaje, te recomendamos que antes de cursar la presente lección, curses primero la Lección:     
                      span
                        | “Los Elementos y Tipos de Crédito”
                    v-card-text.parrafoDestacado18.ml-0.pl-0
                      | Sin embargo, si lo consideras conveniente, puedes continuar en este espacio y cursar la Lección "Descubriendo el Crédito Hipotecario".
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button ', color='primary ', @click.prevent="nextChapter( 'page2-1') ")
                | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false,
      questions: 5
    }
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    nextChapter(page) {
      this.progress = true;
      eventBus.$emit('next_chapter', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    },
    evaluation() {
      var quiz_prefix = 'page1-';
      var quiz_results = Object.keys(this.$parent.results)
        .filter(key => key.indexOf(quiz_prefix) > -1)
        .reduce((obj, key) => {
          obj[key] = this.$parent.results[key];
          return obj;
        }, {});
      return (100 / this.questions * Object.values(quiz_results).reduce((a, b) => a + b, 0)).toFixed(0);;
    }
  }
};
</script>
